module.exports = __webpack_public_path__ + "static/media/fuji-screenshot-3.30d541a7.png";